import $ from 'jquery';

export default function ({
    top = 0,
    duration = 1000,
    easing,
    callback
} = {}) {
    if (callback) {
        $('html,body').animate({scrollTop: top}, duration, easing, callback);
    } else {
        return new Promise(resolve => {
            $('html,body').animate({scrollTop: top}, duration, easing, () => { resolve(); });
        });
    }
}



// WEBPACK FOOTER //
// ./~/@spinnwerk/scroll-helper/lib/scroll-to.js